<script setup lang="ts">
import { computed } from "vue";
import AgentIcon from "~icons/mdi/face-agent";
import type { AgentParam } from "../../common/types.common";
import { defineActions, defineState } from "../common";
import { FormInputCheckbox, FormInputNumeric } from "../input";
import { FormMessage, FormPanel, FormTool } from "../internal";
import { type BaseProps, defaultProps } from "../props";

type ModelType = AgentParam;
interface PropsType extends BaseProps<ModelType> {
    toggleable?: boolean;
    minOutstandingLimit?: number;
}

const props = withDefaults(defineProps<PropsType>(), {
    ...defaultProps<ModelType>(),
    toggleable: false,
    minOutstandingLimit: 50_000,
    value: undefined,
});

const model = defineModel<ModelType>({
    required: true,
});

const state = defineState({
    model: model,
    props: props,
    hasValue: () => {
        if (model.value.isActive) {
            return model.value.outstandingLimit !== undefined;
        } else {
            return true;
        }
    },
});

const actions = defineActions(model, props, state);

const collapsed = computed(() => {
    if (props.toggleable) {
        return !model.value.isActive;
    } else {
        return false;
    }
});

// watch(
//     () => props.toggleable,
//     () => (model.value.isActive = props.toggleable === false),
//     { immediate: true },
// );
</script>

<template>
    <FormPanel :collapsed="collapsed" :param="props">
        <template #header>
            <span class="inline-flex flex-row items-center">
                <FormInputCheckbox
                    v-if="props.toggleable"
                    v-model="model.isActive"
                    class="ml-1"
                    :disabled="!state.editMode"
                    embedMode="inline"
                />
                <AgentIcon class="ml-1 mr-2" />
                <span class="font-semibold text-gray-600 inline-flex flex-row">
                    {{ props.label ?? "Agen Pembayaran" }}
                </span>
            </span>
        </template>

        <template #icons>
            <span class="inline-flex flex-row gap-4">
                <FormTool :actions="actions" :param="props" :showUpdate="true" :state="state" />
            </span>
        </template>

        <div v-if="state.hasError" class="p-4">
            <FormMessage :state="state" />
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <FormInputNumeric
                v-model="model.outstandingLimit"
                embedMode="embed"
                label="Limit Tunggakan"
                :min="minOutstandingLimit"
                :mode="state.nestMode"
                prefix="Rp. "
            />

            <FormInputNumeric
                v-model="model.outstandingBalance"
                embedMode="embed"
                label="Total Tunggakan"
                mode="static"
                prefix="Rp. "
            />
        </div>
    </FormPanel>
</template>
